import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import CheckHotlineHead from "./CheckHotlineHead"
import CheckHotlineBody from "./CheckHotlineBody"

CheckHotlineTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listJobCheck: PropTypes.array
}

function CheckHotlineTable(props) {
    const {loading, error, listJobCheck} = props

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu từ server...">
                <table>
                    <CheckHotlineHead/>
                    <CheckHotlineBody error={error} listJobCheck={listJobCheck}/>
                </table>
            </Spin>
        </div>
    )
}

export default CheckHotlineTable